// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + "." + {"12":"14f04b86","453":"774aa572","777":"f3efc82f"}[chunkId] + ".chunk.js";
};